import { cva } from '@/styled-system/css';

export const toggleButtonLabelRecipe = cva({
  base: {
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'color 200ms ease',
    },
  },
  variants: {
    disabled: {
      true: {},
      false: {},
    },
    loading: {
      true: {
        color: 'transparent.invisible',
      },
      false: {},
    },
    selected: {
      true: {},
      false: {},
    },
    size: {
      sm: {
        textStyle: 'body-sm-bold',
      },
      md: {
        textStyle: 'body-bold',
      },
      lg: {
        textStyle: 'body-bold',
      },
    },
  },
  compoundVariants: [
    {
      selected: false,
      disabled: false,
      loading: false,
      css: {
        color: {
          base: 'ToggleButton.label.default',
          _groupHover: 'ToggleButton.label.hover',
          _groupActive: 'ToggleButton.label.pressed',
        },
      },
    },
    {
      selected: false,
      disabled: true,
      loading: false,
      css: {
        color: {
          base: 'ToggleButton.label.default',
        },
      },
    },
    {
      selected: true,
      disabled: false,
      loading: false,
      css: {
        color: {
          base: 'ToggleButton.label.selected',
          _groupHover: 'ToggleButton.label.selectedHover',
          _groupActive: 'ToggleButton.label.selectedPressed',
        },
      },
    },
    {
      selected: true,
      disabled: true,
      loading: false,
      css: {
        color: {
          base: 'ToggleButton.label.selected',
        },
      },
    },
  ],
});
